import axios from "axios";
const api = import.meta.env.VITE_APP_API;
import authHeader from '../service/auth-header';


const http = axios.create({
  baseURL: api,
  timeout: 100000
});

// KHÔNG thêm auto-retry vào instance này. Các endpoint đổi trạng thái chứng từ
// (PUT APInvoice/APGoldJewelry/ARInvoice/ReturnExchange/ARDpmInvoice...?Status=)
// không idempotent: request có thể đã tới server và tạo phiếu chi xong rồi mới
// timeout ở tầng mạng — retry lúc đó sinh phiếu chi thứ hai. Đúng cơ chế đã tạo
// ra cặp PCTT140319/PCTT140320 cho chứng từ APJ0021167.
// Nếu thật sự cần retry, chỉ bật cho GET và whitelist theo từng endpoint.

http.interceptors.request.use(
  (config) => {
    config.headers.Authorization = authHeader()?.Authorization;
    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => {
    // Xử lý trường hợp status = 204 trả về message
    if (response.status === 204) {
      return response.status
    }
    return response;
  },
  (error) => {

    if (error.status == 401) {
      // Xóa token cũ trước khi về /login, không thì trang login gọi API bằng token hỏng → 401 → lặp vô hạn.
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }

    // if (error.status == 403) window.location.href = '/auth/access';
    if (error.status == 403) {
      alert('Bạn không có quyền truy cập');
    }
    return Promise.reject(error);
  }
);

export default http;